import { findNearestFuture, formatExpiry } from '../../../utils/expiryUtils';

export { findNearestFuture };

/**
 * Extracts unique monthly labels from a set of MCX future results for the Choose Expiry selector.
 * If symbolMatch is provided, strictly filters by that symbol identifier.
 * Uses UTC to prevent IST rollover issues (one day ahead bug).
 */
export function findAvailableExpiries(results, symbolMatch) {
  const now = Math.trunc(Date.now() / 1000);
  const rawResults = Array.isArray(results) ? results : [];

  // Identify all valid, unexpired futures for this commodity
  const allFutures = rawResults.filter((item) => {
    if (item.exchange !== 'MCX') return false;
    const isFut = (item.trading_symbol || '').toUpperCase().endsWith('FUT');
    const isUnexpired = Number(item.expiry) > now;
    if (!isFut || !isUnexpired) return false;
    if (symbolMatch && item.symbol !== symbolMatch) return false;
    return true;
  });

  // Sort by expiry ascending (nearest first)
  const sorted = allFutures.sort((a, b) => Number(a.expiry) - Number(b.expiry));

  // Map to distinct month labels using UTC
  const monthlyMap = new Map();
  sorted.forEach(f => {
    const date = new Date(Number(f.expiry) * 1000);
    // Use UTC timezone to prevent end-of-month rollover in local IST
    const label = date.toLocaleString('en-IN', { month: 'long', timeZone: 'UTC' });
    if (!monthlyMap.has(label)) {
      monthlyMap.set(label, f);
    }
  });

  return Array.from(monthlyMap.entries()).map(([label, f]) => ({
    label,
    token: f.token,
    expiry: f.expiry,
    symbol: f.trading_symbol,
    f: f
  }));
}

export { formatExpiry };
